import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { EnvService } from '../service/env/env.service';
import { UserAccount, UserAccountRequest, UserPageResponse, UserSingleResponse } from './user.model';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  private baseUrl: string;

  constructor(private http: HttpClient, private env: EnvService) {
    this.baseUrl = this.env.apiUrl + '/user';
  }

  /** GET /user?page=&size=&fullName=&userType= */
  getAllUsers(page: number = 0, size: number = 10, fullName?: string, userType?: string): Observable<UserPageResponse> {
    let params = new HttpParams()
      .set('page', page.toString())
      .set('size', size.toString());

    if (fullName && fullName.trim()) {
      params = params.set('fullName', fullName.trim());
    }
    if (userType && userType.trim()) {
      params = params.set('userType', userType.trim());
    }

    return this.http.get<UserPageResponse>(this.baseUrl, { params });
  }

  /** GET /user/:id */
  getUserById(id: number): Observable<UserSingleResponse> {
    return this.http.get<UserSingleResponse>(`${this.baseUrl}/${id}`);
  }

  /** POST /user */
  createUser(request: UserAccountRequest): Observable<UserSingleResponse> {
    return this.http.post<UserSingleResponse>(this.baseUrl, request);
  }

  /** PUT /user/:id */
  updateUser(id: number, request: UserAccountRequest): Observable<UserSingleResponse> {
    return this.http.put<UserSingleResponse>(`${this.baseUrl}/${id}`, request);
  }

  /** DELETE /user/:id */
  deleteUser(id: number): Observable<UserSingleResponse> {
    return this.http.delete<UserSingleResponse>(`${this.baseUrl}/${id}`);
  }

  /** GET /user/types */
  getUserTypes(): Observable<string[]> {
    return this.http.get<string[]>(`${this.baseUrl}/types`);
  }
}
